import $ from 'jquery';
import Swal from 'sweetalert2';
import { initGlobalSelect2 } from './utils/select2-utils';
import { populateForm } from './utils/form-utils';
import { compressImage } from './utils/image-compressor';

export function initGlobalCrud() {
    // 1. Single Edit Modal Population via AJAX (data-url-json)
    $(document).on('click', '[data-url-json]:not(.btn-view-detail):not([class*="btn-edit-"]), [data-url-json].btn-edit-general', async function() {
        let url = $(this).data('url-json');
        
        let modal = $('.modal').first();
        if($(this).data('bs-target')) {
            modal = $($(this).data('bs-target'));
        }
        
        let form = modal.find('form');

        if(url) {
            try {
                const response = await fetch(url);
                const result = await response.json();

                if(result.status === 'success') {
                    // Change title
                    let titleEl = modal.find('.modal-title');
                    if(titleEl.length && titleEl.text().toLowerCase().includes('tambah')) {
                        titleEl.data('original-title', titleEl.text());
                        titleEl.text(titleEl.text().replace('Tambah', 'Edit'));
                    }
                    
                    const modalInstance = window.bootstrap.Modal.getInstance(modal[0]) || new window.bootstrap.Modal(modal[0]);
                    modalInstance.show();

                    // Populate after show
                    await populateForm(form, result.data);
                } else {
                    Swal.fire('Error', result.message || 'Gagal memuat data formulir', 'error');
                }
            } catch (err) {
                Swal.fire('Error', 'Terjadi kesalahan jaringan saat memuat data', 'error');
            }
        }
    });

    // 2. Clear Modal When Hidden (Reset Form)
    $(document).on('hidden.bs.modal', '.modal', function () {
        let form = $(this).find('form');
        if(form.length) {
            // Destroy Select2 instances FIRST before resetting form
            form.find('select.select2-hidden-accessible').each(function() {
                $(this).select2('destroy');
            });

            form[0].reset();
            
            // Clear hidden IDs except CSRF token
            form.find('input[type="hidden"]').filter(function() {
                return !$(this).attr('name').match(/csrf_*/);
            }).val('');
            
            // Reset select values without triggering change (to avoid cascading)
            form.find('select').each(function() {
                $(this).val(null);
            });
            
            // Restore Title
            let titleEl = $(this).find('.modal-title');
            if(titleEl.data('original-title')) {
                titleEl.text(titleEl.data('original-title'));
            }
        }
    });

    // 3. Single Delete with SweetAlert & AJAX
    $(document).on('click', '.btn-delete-submit', function(e) {
        e.preventDefault();
        let $btn = $(this);
        let $form = $btn.closest('form');
        let url = $form.attr('action');
        let method = $form.attr('method') || 'POST';
        
        Swal.fire({
            title: 'Hapus data ini?',
            text: 'Data akan dihapus atau masuk ke Trash.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545', // Danger red
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Ya, hapus!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                // Use AJAX instead of form.submit() to prevent browser navigation to JSON
                $.ajax({
                    url: url,
                    type: method,
                    data: $form.serialize(),
                    success: function(res) {
                        // Check if the response is HTML (traditional redirect back occurred)
                        if (typeof res === 'string' && (res.trim().startsWith('<') || res.trim().indexOf('<!DOCTYPE') !== -1 || res.trim().indexOf('<html') !== -1)) {
                            const $html = $(res);
                            let $flash = $html.find('#flash-messages');
                            if (!$flash.length) {
                                $flash = $html.filter('#flash-messages');
                            }
                            
                            if ($flash.length) {
                                const successMsg = $flash.attr('data-success') || $flash.data('success');
                                const errorMsg = $flash.attr('data-error') || $flash.data('error');
                                
                                if (successMsg && successMsg.trim() !== '') {
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Berhasil!',
                                        html: successMsg,
                                        timer: 1500,
                                        showConfirmButton: false
                                    }).then(() => {
                                        window.location.reload();
                                    });
                                    return;
                                } else if (errorMsg && errorMsg.trim() !== '') {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Gagal!',
                                        html: errorMsg
                                    }).then(() => {
                                        window.location.reload();
                                    });
                                    return;
                                }
                            }
                            window.location.reload();
                            return;
                        }

                        if (res.status === 'success') {
                            Swal.fire({
                                icon: 'success',
                                title: 'Terhapus!',
                                text: res.message,
                                showConfirmButton: false,
                                timer: 1500
                            }).then(() => {
                                // Reload datatables or page
                                const $table = $('.datatable').first();
                                if ($.fn.DataTable && $.fn.DataTable.isDataTable($table) && $table.DataTable().ajax && typeof $table.DataTable().ajax.reload === 'function' && $table.DataTable().ajax.url()) {
                                    $table.DataTable().ajax.reload(null, false);
                                } else {
                                    window.location.reload();
                                }
                            });
                        } else {
                            Swal.fire('Gagal', res.message || 'Terjadi kesalahan saat menghapus data', 'error');
                        }
                    },
                    error: function(xhr) {
                        let msg = xhr.responseJSON ? xhr.responseJSON.message : 'Terjadi kesalahan sistem saat menghapus';
                        Swal.fire('Error', msg, 'error');
                    }
                });
            }
        });
    });


    // 4. Bulk Delete Logic
    $(document).on('change', '#check-all', function() {
        $('.row-select').prop('checked', $(this).prop('checked'));
        toggleBulkDelete();
    });

    $(document).on('change', '.row-select', function() {
        if ($('.row-select:checked').length === $('.row-select').length && $('.row-select').length > 0) {
            $('#check-all').prop('checked', true);
        } else {
            $('#check-all').prop('checked', false);
        }
        toggleBulkDelete();
    });

    function toggleBulkDelete() {
        let count = $('.row-select:checked').length;
        $('#selectedCount').text(count);
        if (count > 0) {
            $('#btnBulkDelete').removeClass('d-none');
        } else {
            $('#btnBulkDelete').addClass('d-none');
        }
    }

    $(document).on('click', '#btnBulkDelete', function() {
        let ids = [];
        $('.row-select:checked').each(function() {
            ids.push($(this).val());
        });

        if (ids.length === 0) return;

        let bulkUrl = $('#page-id').data('bulk-delete-url');
        if(!bulkUrl) {
            Swal.fire('Error', 'URL Bulk Delete belum disetel pada attribute data-bulk-delete-url element #page-id', 'error');
            return;
        }

        // Get CSRF dynamically
        const csrfTokenName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
        const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || '';

        let postData = { ids: ids };
        if(csrfTokenName && csrfHash) {
            postData[csrfTokenName] = csrfHash;
        } else {
            // Fallback: try to find a global csrf input somewhere
            const globalCsrfInput = $('input[name*="csrf_"]').first();
            if(globalCsrfInput.length) {
                postData[globalCsrfInput.attr('name')] = globalCsrfInput.val();
            }
        }

        Swal.fire({
            title: `Hapus ${ids.length} data terpilih?`,
            text: "Data akan dihapus/dipindahkan ke Trash secara rombongan.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Ya, eksekusi!'
        }).then((res) => {
            if (res.isConfirmed) {
                $.post(bulkUrl, postData, function(response) {
                    if (response.status === 'success') {
                        Swal.fire('Terhapus!', response.message, 'success').then(() => {
                            window.location.reload();
                        });
                    } else {
                       Swal.fire('Error', response.message, 'error');
                    }
                }).fail(function(xhr) {
                    Swal.fire('Error', xhr.responseJSON ? xhr.responseJSON.message : 'Terjadi Kesalahan Server', 'error');
                });
            }
        });
    });

    // 5. Global AJAX Form Submission for Modals & Ajax Forms
    $(document).on('submit', 'form', async function(e) {
        let form = $(this);
        let modal = form.closest('.modal');
        
        // Only trigger if the form is inside a modal OR has .ajax-form class
        // AND doesn't have data-no-ajax
        if (!modal.length && !form.hasClass('ajax-form')) return;
        if (form.data('no-ajax') || form.attr('id')?.includes('Import')) return;
        
        e.preventDefault();
        
        let submitBtn = form.find('[type="submit"]');
        let originalBtnHtml = submitBtn.html();

        // Disable button & show loading
        submitBtn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Processing...');

        // Perform Client-Side Image Compression
        let formData = new FormData(this);
        let fileInputs = form.find('input[type="file"]');
        
        for (let i = 0; i < fileInputs.length; i++) {
            let fileInput = fileInputs[i];
            if (fileInput.files && fileInput.files.length > 0) {
                // Determine if this input explicitly opts out of compression
                if ($(fileInput).data('no-compress')) continue;
                
                let file = fileInput.files[0];
                if (file.type.match(/image.*/)) {
                    submitBtn.html('<span class="spinner-border spinner-border-sm me-1"></span> Mengkompresi gambar...');
                    try {
                        let compressedFile = await compressImage(file, 1920, 1920, 0.8);
                        formData.set(fileInput.name, compressedFile);
                    } catch (err) {
                        console.error('Image compression failed for ' + fileInput.name, err);
                        // Fallback to original file automatically handled by FormData
                    }
                }
            }
        }
        
        submitBtn.html('<span class="spinner-border spinner-border-sm me-1"></span> Mengunggah...');

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method') || 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(res) {
                if (res.status === 'success') {
                    if(modal.length) {
                        const modalInstance = window.bootstrap.Modal.getInstance(modal[0]);
                        if(modalInstance) modalInstance.hide();
                    }
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil!',
                        text: res.message,
                        showConfirmButton: false,
                        timer: 1500
                    }).then(() => {
                        // Priority 1: Check for specific table in context or global variable
                        // Priority 2: Reload all .datatable instances if they exist
                        // Priority 3: Fallback to page reload
                        const $datatable = $('.datatable').first();
                        if ($.fn.DataTable && $.fn.DataTable.isDataTable($datatable) && $datatable.DataTable().ajax && typeof $datatable.DataTable().ajax.reload === 'function' && $datatable.DataTable().ajax.url()) {
                            $datatable.DataTable().ajax.reload(null, false);
                        } else if (window.table && window.table.ajax) {
                            window.table.ajax.reload(null, false);
                        } else {
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire('Gagal', res.message || 'Data tidak valid', 'error');
                }
            },
            error: function(xhr) {
                let res = xhr.responseJSON;
                let message = 'Terjadi kesalahan sistem';
                
                if (res && res.message) {
                    message = res.message;
                    if (res.errors) {
                        // Handle CI4 Validation Errors array
                        let errorList = Object.values(res.errors);
                        message = errorList.join('<br>');
                    }
                }
                
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal!',
                    html: message
                });
            },
            complete: function() {
                submitBtn.prop('disabled', false).html(originalBtnHtml);
            }
        });
    });

    // 6. Global Export Chunk Logic
    $(document).on('click', '.btn-global-export', function (e) {
        e.preventDefault();
        
        const baseUrlInit = $(this).data('url-init').split('?')[0];
        const baseUrlChunk = $(this).data('url-chunk').split('?')[0];
        const baseUrlDownload = $(this).data('url-download').split('?')[0];

        const filterParams = new URLSearchParams($('#filterForm').serialize());
        
        // Preserve with_photo if it exists in the original URL or as a data attribute
        const hasPhotoFlag = $(this).data('with-photo') == '1' || $(this).data('url-init').includes('with_photo=1');
        if (hasPhotoFlag) {
            filterParams.set('with_photo', '1');
        }

        const queryString = filterParams.toString();
        const urlInit = baseUrlInit + (queryString ? '?' + queryString : '');
        const urlChunk = baseUrlChunk + (queryString ? '?' + queryString : '');
        const urlDownload = baseUrlDownload + (hasPhotoFlag ? '?with_photo=1' : '');

        $('#exportStatus').text('Menginisialisasi export...');
        $('#exportProgressBar').css('width', '0%').text('0%');
        const modalExport = new window.bootstrap.Modal(document.getElementById('modalExportProgress'));
        modalExport.show();

        // Init export
        $.ajax({
            url: urlInit,
            type: 'GET',
            success: function (res) {
                if (res.csrf_token) {
                    if ($('meta[name="X-CSRF-TOKEN"]').length) {
                        $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                    }
                    $('input[name*="csrf_"]').val(res.csrf_token);
                }

                if (res.status === 'success') {
                    processExportChunk(res.tempFile, 0, 1000, res.totalRows, urlChunk, urlDownload, modalExport);
                } else {
                    Swal.fire('Error', res.message || 'Gagal inisialisasi export', 'error');
                    modalExport.hide();
                }
            },
            error: function (xhr) {
                Swal.fire('Error', xhr.responseJSON?.message || 'Kesalahan server saat inisialisasi', 'error');
                modalExport.hide();
            }
        });
    });

    function processExportChunk(tempFile, offset, chunkSize, totalRows, urlChunk, urlDownload, modalExport) {
        if (totalRows === 0) {
            modalExport.hide();
            Swal.fire('Info', 'Tidak ada data untuk dieksport', 'info');
            return;
        }
        const csrfTokenName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
        const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || $('input[name*="csrf_"]').first().val();

        let postData = {
            tempFile: tempFile,
            offset: offset,
            chunkSize: chunkSize
        };

        if (csrfTokenName && csrfHash) {
            postData[csrfTokenName] = csrfHash;
        }

        $.ajax({
            url: urlChunk,
            type: 'POST',
            data: postData,
            success: function (res) {
                // Update CSRF
                if (res.csrf_token) {
                    if ($('meta[name="X-CSRF-TOKEN"]').length) {
                        $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                    }
                    $('input[name*="csrf_"]').val(res.csrf_token);
                }

                if (res.status === 'success') {
                    let current = Math.min(offset + chunkSize, totalRows);
                    let percent = Math.round((current / totalRows) * 100);
                    $('#exportProgressBar').css('width', percent + '%').text(percent + '%');
                    $('#exportStatus').text(`Mengekspor: ${current} dari ${totalRows} baris...`);

                    if (current < totalRows) {
                        processExportChunk(tempFile, current, chunkSize, totalRows, urlChunk, urlDownload, modalExport);
                    } else {
                        $('#exportStatus').text('Selesai! Mengunduh file...');
                        setTimeout(() => {
                            modalExport.hide();
                            const separator = urlDownload.indexOf('?') !== -1 ? '&' : '?';
                            window.location.href = urlDownload + separator + 'file=' + encodeURIComponent(tempFile);
                        }, 1000);
                    }
                } else {
                    modalExport.hide();
                    Swal.fire('Error', res.message || 'Gagal mengekspor chunk', 'error');
                }
            },
            error: function (xhr) {
                modalExport.hide();
                Swal.fire('Error', xhr.responseJSON?.message || 'Kesalahan server saat mengekspor chunk', 'error');
            }
        });
    }
}
